module.exports = __webpack_public_path__ + "img/img_hope03.56076ab4.jpg";